import { call, put } from "typed-redux-saga";
import { StoreSearchResponse } from "../../core/api/requests/store/search/types";
import { storeLikeApi, storeSearchApi } from "../../core/http/httpClient";
import { ApiResponse } from "../../core/types";
import { convertTime, isTimeBefore } from "../../utils/time";
import { takeEveryFsa } from "../operations";
import { storeActions } from "./actions";
import { Store } from "./types";

export function* storeSaga() {
  yield takeEveryFsa(storeActions.getStores.started, function* (action) {
    const { onComplete, onError, onSuccess, ...body } = action.payload;
    const { response, error }: ApiResponse<StoreSearchResponse> = yield call(
      () => {
        return storeSearchApi
          .call(body)
          .then((response) => ({ response }))
          .catch((error) => ({ error }));
      },
    );

    onComplete?.();

    if (!response || error) return onError?.(error);

    const stores = response.data.stores.map<Store>((store) => ({
      id: store.id,
      name: store.name,
      storeCode: store.store_code,
      service: store.service,
      phoneNumber: store.tel,
      address: store.address,
      area: {
        id: store.area.id,
        name: store.area.name,
      },
      location: {
        altitude: store.location.altitude,
        latitude: store.location.latitude,
        longitude: store.location.longitude,
      },
      prefecture: store.prefecture,
      city: store.city,
      isFavorite: store.favorite,
      isPaymentAvailable: store.is_payment_available,
      shortestTimeUntilPickup: store.shortest_time,
      businessHourOpen: convertTime(store.business_hours.open),
      businessHourClose: convertTime(store.business_hours.close),
      businessHourText: store.business_hours_txt,
      is24Hours: store.business_hours.open === store.business_hours.close,
      isOvernight:
        store.business_hours.open !== store.business_hours.close &&
        isTimeBefore(
          convertTime(store.business_hours.close),
          convertTime(store.business_hours.open),
        ),
      isOrderStopped: store.is_order_stopped,
    }));

    yield* put(
      storeActions.getStores.done({
        params: action.payload,
        result: stores,
      }),
    );
    onSuccess?.(stores);
  });

  yield takeEveryFsa(storeActions.setFavoriteStore.started, function* (action) {
    const { onComplete, onError, onSuccess, ...body } = action.payload;
    const { response, error }: ApiResponse<{}> = yield call(() => {
      return storeLikeApi
        .call(body)
        .then((response) => ({ response }))
        .catch((error) => ({ error }));
    });

    onComplete?.();

    if (!response || error) return onError?.(error);

    yield* put(
      storeActions.setFavoriteStore.done({
        params: action.payload,
        result: response.data,
      }),
    );
    onSuccess?.(response.data);
  });
}
